export const VIEW_FIELD_KEYS = {
	USER_IDENTIFICATION_DETAILS: 'User Identification Details',
	BASIC_USER_INFO: 'basicUserInfo',
	ZUPEE_USER_ID: 'zupeeUserId',
	LUDO_USER_ID: 'ludoUserId',
	PHONE_NUMBER: 'phone',
	ALTERNATE_PHONE_NUMBER: 'alternatePhoneNumber',
	EMAIL: 'email',
	DISPLAY_NAME: 'name',
	GOOGLE_NAME: 'googleName',
	USER_LEVEL: 'level',
	KYC_SUMMARY: 'kycSummary',
	KYC_STATUS: 'kycStatus',
	FULL_NAME: 'fullName',
	FIRST_NAME: 'firstName',
	LAST_NAME: 'lastName',
	DOB: 'dob',
	IS_MINOR: 'isMinor',
	REFERRED_BY: 'referredby',
	USER_TAG: 'userTag',
	USER_STATUS: 'isBlocked',
	USER_FRAUD_STATUS: 'isFraud',
	SIGNUP_TIMESTAMP: 'createdOn',
	SUBSCRIPTION: 'subscription',

	USER_WALLET: 'userWallet',
	TOTAL_BALANCE: 'totalBalance',
	DEPOSIT_MONEY: 'depositMoney',
	WINNINGS: 'winnings',
	BONUS: 'bonus',

	PAYMENT_DETAILS: 'paymentDetails',
	BANK_ACC_NUM: 'accountNumber',
	BANK_IFSC_CODE: 'ifscCode',
	UPI_ID: 'upiId',
	CASHBACK: 'cashback',
	TDS: 'tds',
	USER_SEGMENT: 'userSegment'
};

export const USER_STATUSES = {
	BLOCKED: 'BLOCKED',
	UNBLOCKED: 'UNBLOCKED'
};

export const USER_FRAUD_STATUSES = {
	FRAUD: 'FRAUD',
	FAIR: 'FAIR'
};

export const USER_STATUS_LABEL = {
	[USER_STATUSES.BLOCKED]: 'Blocked',
	[USER_STATUSES.UNBLOCKED]: 'Unblocked'
};

export const USER_FRAUD_STATUS_LABEL = {
	[USER_FRAUD_STATUSES.FRAUD]: 'Fraud',
	[USER_FRAUD_STATUSES.FAIR]: 'Fair'
};

export const USER_STATUS_MAP = {
	0: USER_STATUSES.UNBLOCKED,
	1: USER_STATUSES.BLOCKED
};

export const USER_FRAUD_STATUS_MAP = {
	0: USER_FRAUD_STATUSES.FAIR,
	1: USER_FRAUD_STATUSES.FRAUD
};

export const ACTION_BUTTONS_ID = {
	BLOCK_UNBLOCK_DETAILS: 'blockUnblockDetails',
	UPDATE_ALTERNATE_PHONE: 'updateAlternatePhone',
	VIEW_ALTERNATE_PHONE: 'viewAlternatePhone'
};

export const COLUMNS_NAME_BANK_DETAILS = [
	'AccountHolderName',
	'Account Number',
	'Validated Account Holder Name',
	'Ifsc Code',
	'Validation Source',
	'Is Valid',
	'Is Active',
	'Deactivation Reason',
	'Created At',
	'Updated At'
];

export const COLUMNS_NAME_UPI_DETAILS = [
	'VPA Name',
	'UPI Id',
	'Validation Source',
	'Is Valid',
	'Is Active',
	'Deactivation Reason',
	'Created At',
	'Updated At'
];

export const DETAIL_TYPE_BANK = 'bank_details';
export const DETAIL_TYPE_UPI = 'upi_details';

export const FORM_FIELD_KEYS = {
	TICKET_ID: 'ticketId',
	DESCRIPTION: 'description'
};
